// extracted by mini-css-extract-plugin
module.exports = {"floatingQuoteButton":"FloatingQuoteButton--floatingQuoteButton--3pZ0S","hidden":"FloatingQuoteButton--hidden--26YqV"};